<div class="heading-container">
    <h2>{{heading}}</h2>
</div>
